module.exports = __webpack_public_path__ + "img/intenciones.1c6f80b2.png";